import { Link } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";
import { useReveal } from "@/hooks/useReveal";
import { useSEO } from "@/hooks/useSEO";
import { ARTICLES } from "@/data/articles";
import { SITE_URL } from "@/data/articlesPart1";

export default function Articles() {
  const ref = useReveal();
  useSEO({
    title: "Статьи о мехе, соболе, норке и итальянской моде | Angiolini",
    description:
      "Журнал Angiolini: экспертные статьи об итальянских шубах, мехе соболя, норки и шиншиллы, кашемировых пальто, уходе за мехом и трендах итальянской моды.",
    canonical: `${SITE_URL}/articles`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "Статьи Angiolini",
      url: `${SITE_URL}/articles`,
      isPartOf: { "@type": "WebSite", name: "Angiolini", url: SITE_URL },
    },
  });

  return (
    <main data-testid="articles-page">
      <Navbar solid />
      <section className="pt-40 pb-20" style={{ background: "var(--ink)" }}>
        <div className="pw-container">
          <span className="pw-eyebrow !text-white/50">Журнал Angiolini</span>
          <h1
            className="mt-6 text-white font-semibold"
            style={{ fontSize: "clamp(2.5rem, 5.4vw, 4.5rem)", letterSpacing: "-0.045em", lineHeight: 1.03 }}
          >
            Статьи.
          </h1>
          <p className="mt-6 text-white/55 text-base md:text-lg max-w-xl leading-relaxed">
            Об итальянских шубах, мехе соболя, норки и шиншиллы, кашемире и
            стиле — от экспертов дома Angiolini.
          </p>
        </div>
      </section>

      <section ref={ref} className="py-20 md:py-28" style={{ background: "var(--paper)" }}>
        <div className="pw-container">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-12">
            {ARTICLES.map((a, i) => (
              <Link
                key={a.slug}
                to={`/articles/${a.slug}`}
                data-testid={`article-card-${i}`}
                className="reveal group block"
                style={{ transitionDelay: `${(i % 3) * 80}ms` }}
              >
                <div className="rounded-2xl overflow-hidden aspect-[16/10]">
                  <img
                    src={a.image}
                    alt={a.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
                    style={{ objectPosition: "center 28%" }}
                  />
                </div>
                <div className="mt-5 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.14em]" style={{ color: "var(--grey-2)" }}>
                  <span style={{ color: "var(--accent)" }}>{a.tag}</span>
                  <span>·</span>
                  <span>{a.readTime}</span>
                </div>
                <h2 className="mt-3 text-xl font-semibold leading-snug transition-colors duration-300 group-hover:text-black" style={{ letterSpacing: "-0.02em" }}>
                  {a.title}
                </h2>
                <p className="mt-3 text-[14px] leading-relaxed line-clamp-3" style={{ color: "var(--grey-1)" }}>
                  {a.description}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
